export const PRODUCT_LINK = 'https://gumroad.com/l/fcvOU';
export const FREE_PRODUCT_LINK = 'https://gumroad.com/l/IbZHG';
